import { VisuallyHidden } from "react-aria";

import { useRegisterStore } from "~/stores/use-register-store";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import EndDayScreen from "./end-day-screen";

export default function EndDayDialog() {
  const { endDayOpen, setEndDayOpen } = useRegisterStore();

  return (
    <Dialog open={endDayOpen} onOpenChange={setEndDayOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>End day</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <EndDayScreen />
        </div>
      </DialogContent>
    </Dialog>
  );
}
